// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.custom-modal-37 {
    width: 60rem !important;
    height: 37rem !important;
    display: flex;
    flex-direction: column;
}

.custom-modal-37 .modal-body {
    flex: 1 1;
    overflow-y: auto;
}
`, "",{"version":3,"sources":["webpack://./src/Pages/ValidatorDelegator/LevelUserListModal.css"],"names":[],"mappings":"AAAA;IACI,uBAAuB;IACvB,wBAAwB;IACxB,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,SAAO;IACP,gBAAgB;AACpB","sourcesContent":[".custom-modal-37 {\n    width: 60rem !important;\n    height: 37rem !important;\n    display: flex;\n    flex-direction: column;\n}\n\n.custom-modal-37 .modal-body {\n    flex: 1;\n    overflow-y: auto;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
